// inv/src/pages/solutions/early-stage-startup-founders/blocks/FoundersDiscoverSection.jsx
import { useTranslation } from 'react-i18next';
import CTAHover from '../../../../components/ui/CTAHover';
import { CheckCircle2 } from 'lucide-react';

const FoundersDiscoverSection = ({ bgColor = 'bg-white' }) => {
  const { t } = useTranslation();

  return (
    <section className={`py-16 sm:py-24 ${bgColor}`}>
      <div className="w-[75%] mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <h3 className="text-2xl text-blue-600 font-bold mb-4">
            {t(
              'pageSolutions.EarlyStageFounders.t3',
              'Crino for early-stage founders'
            )}
          </h3>
          <h2 className="text-3xl sm:text-4xl font-semibold text-stone-900">
            {t(
              'pageSolutions.EarlyStageFounders.t4',
              'Discover and prioritise the right investors'
            )}
          </h2>

          <p className="mt-6 text-base leading-7 text-stone-700">
            {t(
              'pageSolutions.EarlyStageFounders.t5',
              'Stop guessing who might be a fit. Crino helps you understand which funds are actively backing companies like yours – by stage, ticket size, sector and geography.'
            )}
          </p>

          {/* modern list, similar to the research block */}
          <ul className="mt-6 space-y-4 text-base leading-7 text-stone-700">
            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t6',
                  'Filter investors by thesis, check size, industry focus and round type.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t7',
                  'See which startups they backed recently and how those deals were structured.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t8',
                  'Build targeted investor lists instead of broad “spray and pray” outreach.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EarlyStageFounders.t9',
                  'Identify under-the-radar funds and angels that match your profile.'
                )}
              </span>
            </li>
          </ul>

          <CTAHover
            className="mt-8"
            text={t(
              'pageSolutions.EarlyStageFounders.t10',
              'Start mapping your ideal investors'
            )}
            href="pricing/"
            align="left"
            bgColor="bg-blue-600 text-white"
            textColor="text-stone-800"
            hoverTextColor="text-white"
          />
        </div>

        <div className="mt-12 lg:mt-0 grid grid-cols-1 gap-4">
          <img
            className="w-full"
            src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/solutions/crino-all-tools-you-need-for-startup-funding.png"
            alt={t(
              'pageSolutions.EarlyStageFounders.alt1',
              'Investor discovery filters and early-stage funding tools for startups'
            )}
          />
        </div>
      </div>
    </section>
  );
};

export default FoundersDiscoverSection;
